import React from 'react';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import withApollo from '../lib/apollo';
import getRedirectCompanyProducts from '../lib/getRedirectCompanyProducts';
import loading from '../lib/loading';

const CompanyLayout = dynamic(() => import('../components/Company/Layout'), {
  ssr: true,
  loading,
});

const CompanyFashionFinder = dynamic(() => import(
  '../components/Company/FashionFinder'
), {
  ssr: true,
  loading,
});

export const CompanyFashionFinderPage = () => {
  const { query: { slug } } = useRouter();

  return (
    <CompanyFashionFinder slug={slug} />
  );
};

CompanyFashionFinderPage.getLayout = (page) => (
  <CompanyLayout layoutMarginBottom="0" throwOnCompanyNotFound>
    {page}
  </CompanyLayout>
);

CompanyFashionFinderPage.getInitialProps = getRedirectCompanyProducts('fashion-finder');

export default withApollo(CompanyFashionFinderPage);
